@if (headerText) {
<h4 class="account-dropdown -heading">
  {{ headerText }}
</h4>
}
<div class="account-dropdown -links">
  @for (dropdownLink of dropdownTo; track dropdownLink) {
  <a [routerLink]="'/' + dropdownLink.path">{{ dropdownLink.title }}</a>
  }
</div>
